<form [formGroup]="form" (ngSubmit)="start()">
    <h2 i18n>Give your stream a title</h2>
    <rr-input label="Title" [FormControl]="$any(form.controls['name'])"></rr-input>
    <div class="w100 row justify-end gap-8">
        <rr-btn type="Secondary" [buttonType]="'button'" (click)="close()">Cancel</rr-btn>
        <rr-btn type="Primary" (click)="start()" cdkFocusInitial>OK</rr-btn>
    </div>
</form>
